import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppDialogService } from '../app-dialogs/app-dialog.service';

@Injectable()
export class FormReferenceService {
  private _unsavedChanges: BehaviorSubject<boolean> = new BehaviorSubject(
    false,
  );
  readonly unsavedChanges$ = this._unsavedChanges.asObservable();

  set unsavedChanges(isDirty: boolean) {
    this._unsavedChanges.next(isDirty);
  }

  get isDirty() {
    return this._unsavedChanges.getValue();
  }
  constructor(private appDialogService: AppDialogService) {}

  public createDialog() {
    const ref = this.appDialogService.openConfirmMatDialog({
      header: 'ui.dialog.button.discardChanges',
      body: 'ui.dialog.discardAllChanges',
      alertType: 'warn',
      reverseActions: true,
      alert: 'ui.dialog.cantBeUndone',
      submitAction: 'ui.dialog.button.keepEditing',
      cancelAction: 'ui.dialog.button.discardChanges',
    });

    return ref.afterClosed();
  }
}
